<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-仓库设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--仓库设置-->
      <div class="common-form">任务中心设置</div>
      <el-form-item label="是否开启任务" prop="is_open_task"><el-switch v-model="formData.is_open_task"></el-switch></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>

  import SettingApi from '@/api/setting.js';
  export default{
    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          is_open_task:false,
        },

      }
    },
    created() {
      this.getParams();
    },
    methods:{

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.getTask({}, true).then(res => {
            if (res.code == 1) {
              self.formData=res.data.vars.values;
              self.loading=false;
            } else {
              console.log();
            }
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.setTask(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/codetemplate/task/setting.vue